import { ConfirmationState } from '@assets/images';
import { createStore } from '@helpers/utils';

export const initialState = {
    isOpen: false,
    isLoading: false,
    title: '',
    desc: '',
    onSubmit: () => {},
    onClose: () => {},
    btnLabelNo: 'Kembali',
    isShowBtnNo: true,
    btnLabelYes: 'Ya, hapus',
    ConfirmationStateImage: ConfirmationState,
    isDanger: true,
};

export const useConfirmModal = createStore(initialState);
